<template>
  <div class="mx-2">
    <v-btn
      v-if="isLink && $store.getters.test('cardDets')"
      :outlined="isLink?true:false"
      :color="isLink?'blue':'black'"
      :to="'/card-'+$store.getters.iface+'/'+removeCoding(cardi)"
      :class="isLink?'card-button':''"
    >
      <v-icon left class="mr-2" color="blue">mdi-information-outline</v-icon>
      <span class="card-bin">{{$store.getters.userbin}}</span>
      <span class="card-number">{{cardi.replace($store.getters.userbin,"") | removeCoding}}</span>
    </v-btn>
    <div v-else>
      <span class="card-bin">{{$store.getters.userbin}}</span>
      <span class="card-number">{{cardi.replace($store.getters.userbin,"") | removeCoding}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    card: String
  },
  data() {
    return {
      cardi: this.card
    };
  },
  computed: {
    isLink() {
      return /[0-9,'=']/gi.test(this.cardi);
    }
  },
  methods: {
    removeCoding(v) {
      try {
        return v.trim().split("=")[0];
      } catch (error) {
        return v;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.card-button {
  border-radius: 5px;
  width: 100%;
}
</style>

